<template>
  <div>
    <v-form ref="chargeCreditForm" v-model="chargeCreditValid">
      <div>
        <v-text-field
          class="mt-3 mb-n2"
          dense
          outlined
          :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"
          required
          type="number"
          label=" مبلغ  ( ریال ) "
          v-model="amount.amount"
          placeholder="صفحه کلید به انگلیسی باشد"
          :hint="
            amount.amount ? amount.amount.num2persian() + ' ( ریال ) ' : ''
          "
        >
        </v-text-field>

        <div class="d-flex flex-row flex-wrap">
          <div
            v-for="(bank, index) in gateways"
            :key="index"
            class="gateway-item"
            :class="bank.id == selectedGateway ? 'selected-gateway' : ''"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <img
                  class="bank-logo"
                  v-bind="attrs"
                  v-on="on"
                  height="45px"
                  :src="
                    bank.logoFileId && bank.logoFileId.thumbnailFileUrl
                      ? bank.logoFileId.thumbnailFileUrl
                      : ''
                  "
                  :alt="
                    bank.logoFileId && bank.logoFileId.alt
                      ? bank.logoFileId.alt
                      : ''
                  "
                  @click="selectBankGateWay(bank)"
                />
              </template>
              <span>{{ bank.paymentMethodName }}</span>
            </v-tooltip>
          </div>
        </div>
      </div>
    </v-form>
    <v-row class="mt-3">
      <v-col cols="6" class="px-1">
        <v-btn
          color="primary"
          small
          block
          @click="onlinePaymentRequest()"
          :disabled="!selectedGateway"
          >پرداخت</v-btn
        >
      </v-col>
      <v-col cols="6" class="px-1">
        <v-btn color="error" block small @click="closeCreditForm()"
          >انصراف</v-btn
        >
      </v-col>
    </v-row>
    <div v-if="onlinePaymentResponse">
      <form
        id="goodsSubmitForm"
        :action="onlinePaymentResponse.redirectToPayUrl"
        method="post"
      >
        <div>
          <input type="hidden" id="amount" name="amount" value="" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const paymentRepository = () => RepoFactory.get('payment');
import Helper from '@/core/helpers';
export default {
  props: {
    needPrice: {
      type: Number,
      default: null,
    },
    retryRequest: {
      type: Boolean,
      default: false,
    },
    selectedPaymentForRetryPay: {
      type: Object,
      default: null,
    },
    objectId: {
      type: String,
      default: null,
    },
    sourceType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      chargeCreditValid: true,
      amount: {
        amount: null,
        currency: 'IRR',
      },
      selectedGateway: null,
      onlinePaymentResponse: null,
      gateways: [],
    };
  },
  created() {
    //console.log("baseUrl is :",location.origin +  this.$route.fullPath)
    this.getGateways();
    if (this.needPrice) {
      this.amount.amount = this.needPrice;
    }
    if (this.retryRequest) {
      this.amount.amount = this.selectedPaymentForRetryPay.amount.amount;
    }
  },
  watch: {
    needPrice(after, before) {
      if (after) this.amount.amount = after;
    },
  },
  methods: {
    onlinePaymentRequest() {
      if (this.$refs.chargeCreditForm.validate()) {
        const loader = this.$loading.show();
        if (this.retryRequest) {
          let body = {
            paymentId: this.selectedPaymentForRetryPay.paymentCoreId,
            gatewayId: this.selectedGateway,
            targetUrl: location.origin + this.$route.fullPath,
            paymentRequester: 'SupplierPanel',
          };
          console.log("body 2 to pay request is:",body)
          paymentRepository()
            .retryPaymentRequest(body, this.$store.getters['paymentBaseUrl'], {
              Authorization: 'Bearer ' + localStorage.getItem('access_token'),
            })
            .then((res) => {
              this.onlinePaymentResponse = res.data;
              console.log("res.data.redirectToPayUrl0000000000",res.data.redirectToPayUrl)
              setTimeout(() => {
                window.open(res.data.redirectToPayUrl,'_self')
              }, 200);


              // setTimeout(() => {
              //   let form = document.getElementById('goodsSubmitForm');
              //   form.submit();
              // }, 300);
            })
            .catch((error) => {
              Helper.handleErrors(error, this);
            })
            .finally(() => {
              loader.hide();
            });
        } else {
          let body = {
            paymentRequester: 'SupplierPanel',
            sourceType: this.sourceType,
            amount: this.amount,
            gatewayId: this.selectedGateway,
            objectId: this.objectId ? this.objectId : null,
            targetUrl: location.origin + this.$route.fullPath,
          };
          console.log("body to pay request is:",body.targetUrl)
          paymentRepository()
            .onlinePaymentRequest(body, this.$store.getters['paymentBaseUrl'])
            .then((res) => {
              this.onlinePaymentResponse = res.data;
              console.log("res.data.redirectToPayUrl0000000000",res.data.redirectToPayUrl)
              setTimeout(() => {
                window.open(res.data.redirectToPayUrl,'_self')
              }, 200);
              // setTimeout(() => {
              //   let form = document.getElementById('goodsSubmitForm');
              //   form.submit();
              // }, 300);
            })
            .catch((error) => {
              Helper.handleErrors(error, this);
            })
            .finally(() => {
              loader.hide();
            });
        }
      } else {
        this.$dialog.error({
          text: 'وارد کردن مبلغ الزامی میباشد',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
      }
    },
    selectBankGateWay(bank) {
      this.selectedGateway = bank.id;
    },
    closeCreditForm() {
      this.$emit('closeCreditForm');
    },
    getGateways() {
      const loader = this.$loading.show();
      paymentRepository()
        .getGateways(this.$store.getters['paymentBaseUrl'])
        .then((res) => {
          this.gateways = res.data;
          if (this.gateways.length > 0) {
            this.selectedGateway = this.gateways[0].id;
          }
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
};
</script>

<style scoped lang="scss">
// @import "~assets/scss/variables";
// @import "~assets/scss/mixins";
.gateway-item {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.bank-logo {
  border-radius: 50%;
}
.selected-gateway {
  border-radius: 50%;
  border: 2px solid rgb(128, 128, 250);
}
</style>
